import {ValueObject} from '@s-ui/domain'

export default class LoginInfoAuthenticationValueObject extends ValueObject {}
